<div [formGroup]="infoForm">
  <mat-card-header>
    <mat-card-title>送付先情報</mat-card-title>
    <mat-icon></mat-icon>
  </mat-card-header>
  <mat-card-content>

    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>郵便番号</mat-label>
        <input matInput
          formControlName="postNo"
          autocomplete="off"
          (blur)="onBlurZipcode()"
          (focus)="onFocusZipcode()"
          required
        />
      </mat-form-field>
      <mat-card-actions style="margin-left: 40px; margin-top: 10px">
        <button type="submit"
          mat-raised-button
          color="primary"
          class="btn btnZipCodeSearch"
          [disabled]="infoForm.contains('postNo') === false || infoForm.get('postNo').value === '' || !infoForm.get('postNo').valid || infoForm.get('postNo').disabled"
          (click)="clickCZipCodeSearch()"
        >検索</button>
      </mat-card-actions>
      <mat-card-actions style="margin-left: 40px; margin-top: 10px">
        <div fxLayout="column wrap" fxLayoutAlign="start">
          <mat-checkbox
            formControlName="cbClmto"
            value="1"
            (change)="onCheckboxChange()"
          >請求先住所</mat-checkbox>
          <mat-checkbox
            formControlName="cbCtrper"
            value="2"
            (change)="onCheckboxChange()"
          >契約者住所</mat-checkbox>
          <mat-checkbox
            formControlName="cbSupplydestination"
            value="3"
            (change)="onCheckboxChange()"
          >供給先住所</mat-checkbox>
          <mat-checkbox
            formControlName="cbInput"
            value="4"
            (change)="onCheckboxInputChange()"
            [checked]="false">手入力</mat-checkbox>
        </div>
      </mat-card-actions>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="start center" *ngIf="isPostnoSearch() === false">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>都道府県</mat-label>
        <input matInput formControlName="pfcAname" autocomplete="off" required/>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>行政市区</mat-label>
        <input matInput formControlName="admncwnm" autocomplete="off" required/>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>行政町名</mat-label>
        <input matInput formControlName="admntnm" autocomplete="off" required/>
      </mat-form-field>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="start center" *ngIf="isPostnoSearch() === true">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>都道府県</mat-label>
        <mat-select formControlName="pfcAnameInput" autocomplete="off" required>
          <mat-option value="" selected></mat-option>
          <mat-option
            *ngFor="let code of pfcAnameList"
            [value]="code.value"
          >{{ code.viewValue }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>行政市区</mat-label>
        <mat-select formControlName="admncwnmInput" autocomplete="off" required>
          <mat-option value="" selected></mat-option>
          <mat-option
            *ngFor="let code of admncwnmList"
            [value]="code.value"
          >{{ code.viewValue }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>行政町名</mat-label>
        <mat-select formControlName="admntnmInput" autocomplete="off" required>
          <mat-option value="" selected></mat-option>
          <mat-option
            *ngFor="let code of admntnmList"
            [value]="code.value"
          >{{ code.viewValue }}</mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30" *ngIf="isPostnoSearch() === false">
        <mat-label>丁目</mat-label>
        <input matInput
          formControlName="chome"
          autocomplete="off" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30" *ngIf="isPostnoSearch() === true">
        <mat-label>丁目</mat-label>
        <mat-select formControlName="chomeInput" autocomplete="off">
          <mat-option value="" selected></mat-option>
          <mat-option
            *ngFor="let code of chomeList"
            [value]="code.value"
          >{{ code.viewValue }}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>番地・号</mat-label>
        <input matInput formControlName="buildingnumber" autocomplete="off"  />
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>住宅・号棟漢字名</mat-label>
        <input matInput formControlName="visitSupadrAname" autocomplete="off" />
      </mat-form-field>
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>屋号・業種漢字名</mat-label>
        <input matInput formControlName="visitYagouAname" autocomplete="off" />
      </mat-form-field>
    </div>
    <div fxLayout="row wrap" fxLayoutAlign="start center">
      <mat-form-field appearance="outline" class="input-form" fxFlex="30" fxFlex.lt-md="30">
        <mat-label>送付先宛名</mat-label>
        <input matInput formControlName="sendtoAddress" autocomplete="off" />
      </mat-form-field>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="end center">
      <mat-card-actions class="btn_area_right">
        <button type="button" mat-raised-button
          color="primary"
          class="btn btnClear"
          (click)="onClickClear()">クリア</button>
      </mat-card-actions>
    </div>
  </mat-card-content>
</div>